<template>
  <div class="ECollapse">
    <slot :class="{ 'disabled-style': disabled }" name="title"></slot>
    <es-collapse-transition>
      <div v-show="active">
        <slot></slot>
      </div>
    </es-collapse-transition>
  </div>
</template>

<style lang="less" scoped>
.ECollapse {
  padding: 20px;
  border: 1px solid #f3f3f3;
  margin: 0 24px;
  .disabled-style {
    color: #999999;
    background: #f3f3f3;
  }
}
</style>

<script>
export default {
  name: 'ECollapse',
  props: {
    active: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    active(val) {
      console.log(val)
    },
  },
}
</script>
